var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"world"},[_c('img',{attrs:{"src":require("../../assets/world.png")}}),_c('div',{staticClass:"cover",class:{right: _vm.value.lng >= 0, top: _vm.value.lat >= 0, bottom: _vm.value.lat < 0, left: _vm.value.lng < 0}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b681c4d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/WorldCoordinates.vue
// module id = null
// module chunks = 